import React from 'react';
import './Hero.css';
import LogosSlider from '../LogosSlider/LogosSlider';
import { Linkedin, Download } from '../../Icons';

export const Hero = () => {
  const navigationTo = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const cvFileUrl = '/cv-agustin.pdf';

  return (
    <div className="hero-container">
      <div className='hero-content-title'>
        <h2>Full-Stack Developer</h2>
      </div>
      <div className='hero-content-description'>
        <p>
          Desarrollador Full Stack especializado en aplicaciones web y sistemas de gestión. Experiencia construyendo
          soluciones en producción con React, JavaScript, Python y Firebase, integrando APIs y servicios cloud para
          automatizar procesos y optimizar operaciones.
        </p>
      </div>

      <div className='hero-secondary-actions'>
        <a 
          href="https://www.linkedin.com/in/agustin-rosano-272542204/" 
          target="_blank" 
          rel="noopener noreferrer"
          className="hero-secondary-btn"
        >
          <Linkedin size={18} />
          LinkedIn
        </a>
        <a 
          href={cvFileUrl} 
          download 
          target="_blank" 
          rel="noopener noreferrer"
          className="hero-secondary-btn"
        >
          <Download size={18} />
          Descargar CV
        </a>
      </div>

      <div className='hero-content-slider'>
        <LogosSlider />
      </div>

      <div className='hero-content-buttons'>
        <button onClick={() => navigationTo('contact')} className='button-contact'>
          Contacto
        </button>
        <button onClick={() => navigationTo('projects')} className='button-Projects'>
          Mis proyectos
        </button>
      </div>
    </div>
  );
};
